export default __webpack_public_path__ + "static/media/SBpic.3ab9c8b7.png";